import React from 'react';
import {
  styled,
  Text,
  Container,
  ContainerPadding,
  TokenTextAppearance
} from '@volkswagen-onehub/components-core';
import { RedirectCTAs } from '..';
import { useWindowHeight, useWindowWidth } from '@react-hook/window-size';
import { Offer } from 'src/types';


const Wrapper = styled.div`
  position: relative;
  width: 100vw;
  height: 100vh;
  min-height: 400px;
  padding: 100px var(--size-grid001) 32px;
  text-align: center;
`;

interface CarImageProps {
  name: string;
  height: number;
  width: number;
}

const CarImage = styled.img<CarImageProps>`
  width: ${(props)=> props.height < 600 ? '90%' : '100%'};
  height: auto;
  position: ${(props)=> props.height < 500 ? 'relative' : 'absolute'};
  margin: 0 auto;
  left:  ${(props)=> props.height < 500 ? null : props.name === 'Taigo' ? null : 'var(--size-grid005)'};
  right: ${(props)=> props.height < 500 ? null : props.name === 'Taigo' ? '0' : null};
  bottom:  ${(props)=> props.height < 500 ? null : '20%'};
  margin-top: ${(props)=> props.height < 500 ? '24px' : null};
  transform: ${(props) => props.height < 600 ? null: 'scale(1.1)' };
  transform-origin: ${(props)=> props.name === 'Taigo' ? 'right bottom' : 'left bottom'};
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column ;
  justify-content: flex-start;
  align-items: flex-start;
`;

interface MobileCardProps {
  offer: Offer;
  numberOfOffers: number;
}

export const MobileCard = (props: MobileCardProps) => {
  const { offer } = props;

  const height= useWindowHeight();
  const width = useWindowWidth();

  return (
    <Wrapper>
      <TextWrapper>
        <Text appearance={TokenTextAppearance.headline400} bold>
          {offer.carlineTitle}{' '}
          <Text appearance={TokenTextAppearance.label200} bold={false}>por</Text>
        </Text>
        <Text appearance={TokenTextAppearance.headline400} bold>
          {' '}{offer.cuota}€ 
          <Text appearance={TokenTextAppearance.label200} bold={false}>/mes<sup>*</sup></Text>
        </Text>
        <Container padding={{bottom: ContainerPadding.static250, }}>
          <Text appearance={TokenTextAppearance.headline400} bold>
            <Text appearance={TokenTextAppearance.label200} bold={false}>con{' '}</Text>
            My Renting
          </Text>
        </Container>
        <RedirectCTAs offer={offer} />
      </TextWrapper>

      <CarImage height={height} width={width} name={offer.carlineTitle} src={offer.mediaAssets.D6MOFASideview} alt={offer.carlineTitle} />
      
    </Wrapper>
  );
};
